import React from 'react';

export default function Footer() {
  return (
    <footer className="mid-col">
      <div className="source">
        Source: Australian Electoral Commision
        <br />
        Only polling locations with latitude and longitude used.{' '}
      </div>
    </footer>
  );
}
